import React, { memo } from 'react';
import { Controller } from 'react-hook-form';
import { Accordion, AccordionTab } from 'primereact/accordion';
import WheelOptionTiles from './WheelOptionTiles';
import {
  WHEEL_LOCATION_ITEMS,
  formatWheelLocationItemTitle,
} from '../../constants/WheelInspectionConstants';
import {
  DEFAULT_LOCATION_DETAIL,
  getWheelInspectionFieldPath,
  getWheelPositionGroupLabel,
} from '../../utils/wheelInspectionUtil';

const preserveScroll = (callback) => (value) => {
  const scrollY = window.scrollY;
  callback(value);
  requestAnimationFrame(() => {
    window.scrollTo(0, scrollY);
  });
};

const WheelLocationTable = ({ positions, control, readOnly = false }) => (
  <Accordion multiple activeIndex={[]} className="wheel-location-accordion">
    {positions.map((p) => (
      <AccordionTab key={p.code} header={getWheelPositionGroupLabel(p.code)}>
        <div className="flex flex-column gap-2">
          {WHEEL_LOCATION_ITEMS.map((item) => (
            <div key={`${p.code}_${item.key}`} className="wheel-location-position-item">
              <div className="wheel-location-position-item__title">
                {formatWheelLocationItemTitle(item)}
              </div>
              <div className="wheel-location-position-item__value">
                <Controller
                  control={control}
                  name={getWheelInspectionFieldPath(
                    `locationDetail.${p.code}.${item.key}`
                  )}
                  defaultValue={item.manualOnly ? '' : DEFAULT_LOCATION_DETAIL[item.key]}
                  render={({ field }) => (
                    <WheelOptionTiles
                      type="radio"
                      options={item.options}
                      value={field.value}
                      onChange={preserveScroll(field.onChange)}
                      disabled={readOnly}
                      layout="vertical"
                      tileClassName="wheel-option-tile--result wheel-option-tile--location"
                    />
                  )}
                />
              </div>
            </div>
          ))}
        </div>
      </AccordionTab>
    ))}
  </Accordion>
);

export default memo(WheelLocationTable);
